import "../style.css";

function TextAndUnderlineComponent({
  value,
  unit,
  posx,
  posy,
  fontSizeValue,
  fontSizeUnit,
  underline = true,
  gap = 0,
}) {
  return (
    <div
      className="container-component"
      style={{
        top: `${posy}%`,
        left: `${posx}%`,
        position: "absolute",
      }}
    >
      <span className="value" style={{ fontSize: fontSizeValue }}>
        {value}
      </span>
      {underline && (
        <span className="unit" style={{ fontSize: fontSizeUnit, marginTop: gap }}>
          {unit}
        </span>
      )}
    </div>
  );
}
export default TextAndUnderlineComponent;
